import { MRT_ColumnDef } from 'material-react-table';
import { useEffect, useMemo, useState } from 'react';
import { useParams } from 'react-router-dom';
import { StandardTablePanel } from '../../../_components/panel/standardTable.panel';
import { TABLE_FILTER } from '../../../_const/tableFilter.const';
import { handleErrorResponse } from '../../../_helpers/handleResponse.helper';
import { logService } from '../../../_services/log.service';
export function ClientLogPanel() {
    const { clientId } = useParams<{ clientId: string }>();

    const [data, setData] = useState({ items: [], count: 0 });
    const [isLoading, setIsLoading] = useState(false);
    const [filter, setFilter] = useState({ ...TABLE_FILTER });

    useEffect(() => {
        fetchData();
    }, [filter]);

    const fetchData = async () => {
        setIsLoading(true);
        return await logService.getClientLogs(clientId, filter)
            .then(
                json => {
                    setData(json);
                }, handleErrorResponse)
            .finally(() => {
                setIsLoading(false);
            });
    };

    const columns = useMemo<MRT_ColumnDef<any>[]>(
        () => [
            {
                accessorKey: 'userName',
                header: 'User',
            },
            //{
            //    accessorKey: 'entityName',
            //    header: 'Section',
            //},
            {
                accessorKey: 'propertyName',
                header: 'Field',
            },
            {
                accessorKey: 'newValue',
                header: 'New Value',
            },
            {
                accessorKey: 'oldValue',
                header: 'Old Value',
            },
        ],
        [],
    );

    return (
        <>
            <StandardTablePanel
                title="Logs"
                columns={columns}
                data={data}
                filter={filter}
                setFilter={setFilter}
                loading={isLoading}
                enableBottomToolbar={true}
            />
        </>
    );
}